<!-- FILTERS -->
<div class="row mb-3">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header" (click)="isFilterOpen = !isFilterOpen" style="cursor:pointer">
        <i class="fa fa-filter"></i> Filters
        <div class="pull-right">
          @if (isFilterOpen) {
            <i class="fa fa-chevron-down"></i>
          } @else {
            <i class="fa fa-chevron-left"></i>
          }
        </div>
      </div>
      <div class="card-body" [collapse]="!isFilterOpen">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label>Transaction Type</label>
              <select class="form-control" [(ngModel)]="requestFilters.transaction_type">
                <option [ngValue]="undefined">All</option>
                @for (key of $any(UserCurrencyTransactionType) | keyvalue; track key.key) {
                  @if (!isNaN(+key.value) && +key.value !== 0) {
                    <option [ngValue]="+key.value">{{ key.key }}</option>
                  }
                }
              </select>
            </div>
          </div>
        </div>
        <div class="filters-buttons">
          <button [disabled]="isLoading" class="btn btn-sm btn-primary" (click)="onClickFilter()"><i class="fa fa-filter"></i> Filter</button>
          <button [disabled]="isLoading" class="btn btn-sm btn-danger" (click)="onClickResetFilters()"><i class="fa fa-ban"></i> Reset</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- LIST -->
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-list"></i> Transactions
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Date</th>
              <th>Currency</th>
              <th>Quantity</th>
              <th>Quantity Final</th>
              <th>Shop Package</th>
              <th>Shop Price</th>
            </tr>
          </thead>
          <tbody>
            @for (transaction of transactions; track $index; let i = $index) {
              <tr>
                <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                <td>{{ UserCurrencyTransactionType[transaction.transactionType] }}</td>
                <td>{{ transaction.createdAtTimestamp !== 0 ? dateService.getDateFromatted(transaction.createdAtTimestamp) : '-' }}</td>
                <td>
                  {{ UserCurrencyType[transaction.currencyType] }}
                  @if (transaction.currencyTicketCost > 0) {
                    <span class="text-muted">({{ transaction.currencyTicketCost }})</span>
                  }
                </td>
                <td>{{ transaction.currencyQuantity }}</td>
                <td>{{ transaction.currencyAccountAmountFinal }}</td>
                <td>{{ transaction.transactionShopPackageId ?? '-' }}</td>
                <td>{{ transaction.transactionShopPrice > 0 ? transaction.transactionShopPrice : '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + transactions.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="transactions.length < resultsPerPage">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="transactions.length < resultsPerPage">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
